<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div
    v-if="results && results.length > 0"
    id="materials"
    class="nopads"
  >

      <vue3-datatable
          ref="resultTable"
          :rows="results"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="100%"
          :sortable="true"
          skin="bh-table-compact"
          :row-class="'routa-table-row'"
          cell-class="routa-table-cell"
      >
          <template #certificates="row">
              <div>
                  {{ getCertificates(row.value.certificates) }}
              </div>
          </template>
      </vue3-datatable>
  </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {printHelper} from '../mixins/PrintMixin'
import {restApi} from '../mixins/RestApiMixin'
import {vehicleHelper} from '../mixins/VehicleMixin'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'TeamReportDetails',
    components: {Vue3Datatable},
    mixins: [timeUtils, printHelper, restApi, vehicleHelper],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            fields: [
                {field: 'first_name', title: this.$t('work_report.first_name'), sort: false},
                {field: 'last_name', title: this.$t('work_report.last_name'), sort: false},
                {field: 'tax_number', title: this.$t('users.tax_number'), sort: false},
                {field: 'certificates', title: this.$t('menu.certificates'), sort: false}
            ],
        }
    },
    methods: {
        getCertificates: function (certificates) {
            var string = ''
            certificates.forEach(function (certificate) {
                if (string.length !== 0) {
                    string += ', '
                }
                string += certificate.type.name
                if (certificate.expiration_day) {
                    string += ' - '
                    string += this.getShortDateString(certificate.expiration_day)
                }
            }, this)
            return string
        }
    }
}
</script>
